import { injectMocks } from '@jfs/network'
import { createRoot } from 'react-dom/client'
import App from './App'
import './assets/index.css'
import './ieConfig/MobxConfig'
import './ieConfig/Polyfills'
import { mocks } from './mocks'

export const isFromMock = false
if (isFromMock) {
  injectMocks(mocks, 'default', undefined, sessionStorage.getItem('activeMocks') ?? undefined)
}

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
